export const HTTP_METHODS = {
  POST: 'POST',
};

export const MEMBERSHIP_DOMAIN_CLIENT_ID = 'TLS-PERSONALIZATION_TRAVEL-SUBNAV';
export const MEMBERSHIP_DOMAIN_CHANNEL = 'online';
export const PWP_ERROR_CODE = 'GBLEXT_2501';
export const PERSONA_CLIENT_ID = '684C957199C3BE6C153A778D1986032B';
